import { render, staticRenderFns } from "./ResetComplete.vue?vue&type=template&id=21efd401&scoped=true&"
import script from "./ResetComplete.vue?vue&type=script&lang=js&"
export * from "./ResetComplete.vue?vue&type=script&lang=js&"
import style0 from "./ResetComplete.vue?vue&type=style&index=0&id=21efd401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efd401",
  null
  
)

export default component.exports